import Container from '../components/Container';

export default function Terms() {
  return (
    <Container narrow>
      <article className="djinn-prose">
        <h1>Terms of Service</h1>
        <p className="text-sm text-djinn-text-muted">
          Last updated: {new Date().getFullYear()}
        </p>

        <h2>1. The service</h2>
        <p>
          Djinn Coach is a fitness-coaching application. Training advice generated by the app is
          for general information only and is <strong>not</strong> medical advice. Consult a
          qualified professional before starting any exercise programme.
        </p>

        <h2>2. Your account</h2>
        <p>
          You are responsible for keeping your login credentials secure and for all activity on
          your account.
        </p>

        <h2>3. Acceptable use</h2>
        <p>
          Do not use the app to harass others, attempt to reverse-engineer the service or
          interfere with its operation.
        </p>

        <h2>4. Subscriptions and payments</h2>
        <p>
          Paid features are billed through the Apple App Store or Google Play. Refunds are
          handled by those platforms under their own policies.
        </p>

        <h2>5. Disclaimer of warranty</h2>
        <p>
          The service is provided "as is" without warranty of any kind. We do not guarantee that
          the AI coach will be free of errors.
        </p>

        <h2>6. Contact</h2>
        <p>
          Questions? Email <a href="mailto:support@djinncoach.com">support@djinncoach.com</a>.
        </p>
      </article>
    </Container>
  );
}
